import { render } from "./setting-standard.vue?vue&type=template&id=1aaf1f5c&scoped=true"
import script from "./setting-standard.vue?vue&type=script&lang=js"
export * from "./setting-standard.vue?vue&type=script&lang=js"

import "./setting-standard.vue?vue&type=style&index=0&id=1aaf1f5c&lang=css"
import "./setting-standard.vue?vue&type=style&index=1&id=1aaf1f5c&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aaf1f5c"]])

export default __exports__